module.exports = __webpack_public_path__ + "static/img/star.df57bc6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/star.png
// module id = 40
// module chunks = 1